import React from 'react';

import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import Lozenge from '@atlaskit/lozenge';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { AiInformationIcon } from '@atlassian/jira-atlassian-intelligence';
import { useIntl } from '@atlassian/jira-intl';
import { AiIcon } from '../ai-icon';
import messages from './messages';

export const Footer = () => {
	const { formatMessage } = useIntl();
	return (
		<Container>
			<AiInformationIcon />
			<Button
				appearance="subtle-link"
				spacing="none"
				href="https://www.atlassian.com/trust/atlassian-intelligence"
				rel="noopener noreferrer"
				target="_blank"
				testId="issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.footer.info-message"
			>
				{formatMessage(messages.infoText)}
			</Button>
			<Lozenge
				testId="issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.footer.beta-lozenge"
				appearance="new"
			>
				{formatMessage(messages.betaLozenge)}
			</Lozenge>

			<FooterSectionSpacer />
			<FooterText>{formatMessage(messages.aiText)}</FooterText>
			<AiIcon label="" />
		</Container>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	padding: token('space.150', '12px'),
	gap: token('space.025', '2px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderTop: `1px solid ${token('color.background.accent.gray.subtler', colors.N40)}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FooterText = styled.div({
	color: token('color.text.subtlest', '#626F86'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FooterSectionSpacer = styled.div({
	flexGrow: 1,
});
